/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
	auth: {
		clientId: '48893735-bf0a-441d-8e96-fcb3fa8f78c0',
		authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
		redirectUri: process.env.REACT_APP_REDIRECT_URL || 'https://localhost:3000' // env variable in static web app or localhost url
	},
	cache: {
		cacheLocation: 'sessionStorage', // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {	
		loggerOptions: {	
			loggerCallback: (level: any, message: any, containsPii: any) => {	
				if (containsPii) {		
					return		
				}		
				switch (level) {		
				case LogLevel.Error:		
					console.error(message)		
					return		
				case LogLevel.Info:		
					console.info(message)		
					return		
				case LogLevel.Verbose:		
					console.debug(message)		
					return		
				case LogLevel.Warning:		
					console.warn(message)		
					return		
				}	
			}	
		}	
	}
}

export const apiConfig = {
	resourceUri: 'https://localhost:7042/',
	resourceScopes: ['api://a4d87720-db8b-4839-94f6-9f5c7a03e80b/.default']
}

export const tokenRequest = {
	scopes: [...apiConfig.resourceScopes]
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: ['User.Read'] //, 'Contacts.Read'] -> Need admin consent to read contacts and get their photos from Microsoft Graph
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
	graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
